import { branch, renderComponent } from 'recompose'

export default branch(
  (ownProps) => ownProps.data.length === 0,
  renderComponent(() => null)
)
